import React, { Component } from 'react';
import { Info, XCircle, Loader, AlertCircle } from 'react-feather';
import { save } from '../cruds/restApi';
import { classNames } from '../functions/classNames';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import InputUpload from '../components/input/InputUpload';
import MainContainer from '../components/MainContainer';
import { HorizontalInput, VerticalInput } from '../components/container/LayoutRow';
import { SubmitButton } from '../components/output/Button';
import './Import.css';

const ImportButton = ({ disabled }) => (
  <SubmitButton disabled={disabled} label="import.submit" />
);

const ImportResultRowIcon = ({ type }) => {
  if (type === 'INFO') {
    return <Info size={17} />;
  }

  if (type === 'WARNING') {
    return <AlertCircle size={17} />;
  }

  if (type === 'ERROR' || type === 'GENERAL' || type === 'PERSISTENCE') {
    return <XCircle size={17} />;
  }

  return '';
};

const ImportResultRow = ({ type, message }) => (
  <div className="ImportResultRow">
    <div className={classNames('type', type)}><ImportResultRowIcon type={type} /></div>
    <div className="message">{message}</div>
  </div>
);

const ImportResults = ({ loading, title, results, error, style }) => {
  if (loading) {
    return <div className="loading"><Loader size={17} /></div>;
  }

  if (!results && !error) {
    return <div></div>;
  }

  if (!results && error) {
    return <div className="ImportResults" style={style}>
              <div className="title">{title}</div>
              <ImportResultRow type={error.code} message={error.message} />
            </div>;
  }

  return <div className="ImportResults" style={style}>
            <div className="title">{title}</div>
            {results.map((r, i) => <ImportResultRow key={i} type={r.type} message={r.message} />)}
          </div>;
};

class Import extends Component {
  constructor(props) {
    super(props);
    this.state = { resource: {}, lock: true, reset: false, importing: false };
  }

  handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    let updated = { ...this.state.resource };
    updated[name] = value;

    this.setState({
      resource: updated,
      reset: false,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
          reset: true,
          importing: true,
        }, this.handleUpload);
  };

  handleUpload = () => {
    save('import', this.state.resource)
      .then(res => this.handleUploadSuccess(res))
      .catch(res => this.handleUploadException(res));
  };

  handleUploadSuccess = (res) => {
    this.setState({
      resource: {},
      lock: true,
      results: res.value,
      reset: false,
      importing: false,
    });
  };

  handleUploadException = (res) => {
    this.setState({
      resource: {},
      lock: true,
      error: res,
      reset: false,
      importing: false,
    });
  };

  handleLockSubmit = (value) => {
    this.setState({ lock: value });
  };

  render() {
    const { resource, results, error, reset, lock, importing } = this.state;

    return (
      <MainContainer>
        <div className="Crud Edit Import">
          <h2>{getLabel(this.context.locale, 'header.importSubstances')}</h2>
          <form onSubmit={this.handleSubmit}>
          <div hidden={importing}>
            <HorizontalInput value={resource} handleChange={this.handleChange} style={{ alignItems: 'flex-start' }}>
              <VerticalInput style={{ flex: 1 }}>
                <InputUpload name="value"
                  to="attachments"
                  handleLockSubmit={this.handleLockSubmit}
                  reset={reset}                
                />
                <ImportButton disabled={importing || lock} />
                </VerticalInput>
              <ImportResults style={{ flex: 1 }}
                  title={getLabel(this.context.locale, 'import.results')}
                  results={results}
                  error={error}
                  loading={importing}
              />
            </HorizontalInput>
              <div style={{marginTop: "30px"}} hidden={importing || lock}><Info size={17} />  Riceverai una mail con i risultati ad importazione conclusa.</div>
              </div>
              <div style={{marginTop: "30px",  textAlign: 'center'}} hidden={!importing}><div className="loading"><Loader size={17} /></div> Il sistema sta finendo l'importazione, riceverai una mail con i risultati ad importazione conclusa.</div>
          </form>
        </div>
      </MainContainer>
    );
  }
}

Import.contextTypes = {
  locale: PropTypes.string,
};

export default Import;



// WEBPACK FOOTER //
// ./src/main/pages/Import.js